'use strict';

const operations = require('../../rlink-collections/operations');

const CACHES_SHAPE = require('./CACHES_SHAPE');

module.exports = function reduceDataCaches (caches, { type, payload, meta }) {
  switch (type) {
  case 'DATA_CONNECTOR_SET_REQUEST_PENDING':
    return CACHES_SHAPE.updateAt(caches, [
      [meta.reference.storagePath('pending'), operations.set, true],
      [meta.reference.storagePath('meta'), operations.set, meta],
      [meta.reference.storagePath('cancelled'), operations.set, false],
      [meta.reference.storagePath('timeoutId'), operations.set, null],
    ]);
  case 'DATA_CONNECTOR_STORE_RESOLVED_CACHES':
    return CACHES_SHAPE.updateAt(caches, [
      [[], operations.set, payload],
    ]);
  case 'DATA_CONNECTOR_SET_REQUEST_FAILED':
    return CACHES_SHAPE.updateAt(caches, [
      [meta.reference.storagePath('timestamp'), operations.set, new Date()],
      [meta.reference.storagePath('pending'), operations.set, false],
      [meta.reference.storagePath('error'), operations.set, true],
      [meta.reference.storagePath('timeoutId'), operations.set, null],
    ]);
  case 'DATA_CONNECTOR_CANCEL_REQUEST':
    return CACHES_SHAPE.updateAt(caches, [
      [meta.reference.storagePath('timestamp'), operations.set, new Date()],
      [meta.reference.storagePath('pending'), operations.set, false],
      [meta.reference.storagePath('cancelled'), operations.set, true],
    ]);
  case 'DATA_CONNECTOR_SET_REQUEST_TIMEOUT_ID':
    return CACHES_SHAPE.updateAt(caches, [
      [meta.reference.storagePath('timeoutId'), operations.set, payload.timeoutId],
    ]);
  default:
    return caches;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/reduceDataCaches.js